import { RetirementApp } from 'app/containers/RetirementApp/index'
import 'app/utils/highcharts/config'
import { loadSiteConfig } from 'config'
import { ConfigNames } from 'config/interfaces'
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { AppContainer } from 'react-hot-loader'
import * as smoothscroll from 'smoothscroll-polyfill'
import { medicalQuestionInfo } from '../PipelineSection/Expenses/Medical';

smoothscroll.polyfill() //polyfill ScrollIntoView

const rootEl = document.getElementById('root')
declare const CONFIG_NAME: ConfigNames

/**
 * Renders the Application to the DOM
 * @param AppElement
 */
const renderApp = (AppElement: React.ComponentType<any>) => {
  if (CONFIG_NAME === '697') {
    medicalQuestionInfo.footer = () => (<span>
      Medical expenses include all premiums and out-of-pocket costs (e.g., co-pays, prescriptions).
      Additional information on Plan P premiums may be found <a href="#/Pension/plan_p_benefit">here</a>.
      </span>)
  }
  const renderElement = (
    <AppContainer>
      <AppElement />
    </AppContainer>
  )

  ReactDOM.render(renderElement, rootEl)
}

//Init App
loadSiteConfig()
  .then(() => {
    renderApp(RetirementApp)
  })
  .catch((reason) => {
    // for now, if the config load fails, proceed. This handles the situation of legacy sites that
    // have not yet moved their configuration to .json files.
    renderApp(RetirementApp)
  })

// Hot-reloads components while developing
if (module.hot) {
  module.hot.accept('./index', () => {
    const updatedAppModule = require('./index') as any

    renderApp(updatedAppModule.RetirementApp)
  })
}



// WEBPACK FOOTER //
// ./src/app/containers/RetirementApp/entry.tsx